import { AddSchema } from '../../schemas/add'
import { Variables } from './api'

export const mapper = (data: AddSchema): Variables => ({ ...data })
